module.exports = __webpack_public_path__ + "media/images/icons/icon_google-9a7b1226e8c138181c34cf467a2cd026.svg";